import { useContext } from "react";
import { LanguageContext } from "@eriksdigital/atomic-ui/components";

const useBasenamePath = (): string => {
  const { language } = useContext<any>(LanguageContext);
  return `/${language}/plastics-configurator`;
};

export default useBasenamePath;
